export enum Tables {
  assignment = 'Assignment',
  assignmentDetails = 'Assignment_details',
  queue = 'Queue'
}
